package com.snakesworld.game.network

actual fun createDefaultMultiplayerRepository(): MultiplayerRepository {
    return FirebaseMultiplayerRepository()
}
